// TODO: Fix eslint errors.
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-plusplus */
/* eslint-disable radix */

import searchParamsStringify from '@Utils/searchParamsStringify';

function buildSearchListPager(pageType, searchParams, totalMatches, searchUrl) {
  const currentPage = searchParams.page ? searchParams.page : 1;
  const pager = {
    previous: {},
    next: {},
    pages: [],
    current: currentPage,
  };

  const pages = Math.ceil(totalMatches / parseInt(process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE));
  let page = 1;
  const pageNumbers = pages > 5 ? 4 : pages;

  // Build link to previous page.
  if (searchParams.page > 1) {
    const pagerBuilder = { ...searchParams };
    pagerBuilder.page = parseInt(pagerBuilder.page) - 1;
    if (pagerBuilder.page === 1) {
      pagerBuilder.page = null;
    }
    const url = `${searchUrl}${searchParamsStringify(pageType, pagerBuilder)}`;

    pager.previous = {
      url,
      // mousedown: dataLayer.buildPaginationClickEvent(pagerBuilder.page),
    };
  }

  // Build link for next page.
  if (searchParams.page === 0 || searchParams.page < pages - 1 || !searchParams.page) {
    const pagerBuilder = { ...searchParams };
    pagerBuilder.page = pagerBuilder.page ? parseInt(pagerBuilder.page) + 1 : 2;
    const url = `${searchUrl}${searchParamsStringify(pageType, pagerBuilder)}`;
    pager.next = {
      url,
      // mousedown: dataLayer.buildPaginationClickEvent(pagerBuilder.page),
    };
  }

  if (currentPage > 2) {
    page = currentPage - 2;
  }

  if (pages > 1) {
    while (pager.pages.length <= pageNumbers && page <= pages) {
      const pagerBuilder = { ...searchParams };
      pagerBuilder.page = page;
      if (pagerBuilder.page === 1) {
        pagerBuilder.page = null;
      }

      const url = `${searchUrl}${searchParamsStringify(pageType, pagerBuilder)}`;

      pager.pages.push({
        url,
        text: page,
        isCurrent: page === parseInt(currentPage),
        // mousedown: dataLayer.buildPaginationClickEvent(page),
      });
      page++;
    }
  }

  return pager;
}

export default buildSearchListPager;
